import React from 'react'
import {
  type AppointmentEventType,
  EventTypeName,
  LanguageUtils,
  StateLabel,
  type StateLabelProps,
} from '@pbt/pbt-ui-components'

import { getAppointmentColorState } from '~/components/dashboard/timetable/timetableUtils'
import { useFilteredAppointmentStatuses } from '~/utils/appointmentStatusUtils'
import { useEventType } from '~/utils/useEventType'

export interface AppointmentStateLabelProps extends StateLabelProps {
  item?: {
    state?: {
      id: string
      name: string
    }
  }
}

const AppointmentStateLabel = ({
  item,
  ...rest
}: AppointmentStateLabelProps) => {
  const AppointmentStatuses: AppointmentEventType['states'] = useEventType(
    EventTypeName.Appointment,
    'states',
  )

  const filteredStatuses = useFilteredAppointmentStatuses(AppointmentStatuses)

  const displayName = LanguageUtils.getConstantTranslatedName(
    item?.state?.id,
    filteredStatuses,
  )

  return (
    <StateLabel
      display="inline"
      {...{ [getAppointmentColorState(item?.state?.name)]: true }}
      {...rest}
    >
      {displayName}
    </StateLabel>
  )
}

export default AppointmentStateLabel
